import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const TOexposicaoprofissional = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if(ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="EXPOSIÇÃO DOS PROFISSIONAIS A DOENÇAS INFECTO-CONTAGIOSAS E UTILIZAÇÃO E DISPONIBILIDADE DE EPI" />
                    <div style={{ textAlign: "left" }}>
                        <Select label="Profissional(s) que atua na EMERGÊNCIA com paciente(s) suspeito ou contaminado com doenças que necessitem de isolamento por gotículas e/ou aerossol" nome="tocontaminado" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Profissional(s) que atua na UTI com paciente(s) suspeito ou contaminado com doenças que necessitem de isolamento por gotículas e/ou aerossol" nome="todoenca" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Profissional(s) que atua na ENFERMARIA com paciente(s) suspeito ou contaminado com doenças que necessitem de isolamento por gotículas e/ou aerossol" nome="todoencaenf" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Profissional(s) que atua no AMBULATÓRIO com paciente(s) suspeito ou contaminado com doenças que necessitem de isolamento por gotículas e/ou aerossol" nome="todoencaambu" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Máscara Cirúrgica" nome="toexpocirurgica" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Máscara N95" nome="toexpon95" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Avental/Capote" nome="toexpoavental" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Protetor Facial/Óculos de Proteção" nome="toexpooculos" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Luvas" nome="toexpoluva" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Touca de Proteção" nome="totouca" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="TODOS os profissionais lotados no serviço possuem EPI específico para o seu local de atuação" nome="toexpolotado" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                               <HeaderVerde texto="Legalidade" />
                        <Select label="Norma Técnica Sanitária Vigente" nome="toexpotec" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                    </div>
                </Caixa>
            )
        }
        return partes
    }
}

export default TOexposicaoprofissional